import { createApp } from 'vue';
import Main from './NotificationsCounterMain.vue';
import Mob from './NotificationsCounterMob.vue';

// Просто маунтит 2 экземпляра в указанные mount-point

createApp(Main)
    .mount('#notifications-counter-main');

createApp(Mob)
    .mount('#notifications-counter-mob');    